<div class="actions-wrapper">
  <button
    type="button"
    class="usa-button"
    [disabled]="!filtersStatus() ? 'disabled' : null"
    (click)="onApplyFilters()"
  >
    Apply filters
    @if (currentCount() > 0) {
      <span class="usa-tag" aria-hidden="true">{{ currentCount() }}</span>
    }
  </button>
  @if (currentCount() > 0) {
    <button type="button" class="usa-button usa-button--unstyled" (click)="onClearFilters()">
      Clear
    </button>
  }
</div>
